export const promotionsDusitThaniManila = [
  {
    title: "3 Christmas Afternoon Tea Buffet",
    description:
      "Spend Christmas afternoon at Lobby Lounge and indulge in our afternoon tea buffet.",
    date: "25 Dec 2024",
    image: "/promotions/1.png",
    url: "https://www.dusit.com/dusitthani-manila/specialoffers/?gad_source=1&gclid=Cj0KCQiA8fW9BhC8ARIsACwHqYqrZq8c-7qn5m8GuzoNQh2G7GxH2sK-3SiOYYgCMYMhpxt828d32REaArXgEALw_wcB",
  },
  {
    title: "Shangri-La E-Boutique Spa Vouchers",
    description:
      "Treat yourself to a soothing massage with our exclusive spa vouchers.",
    date: "02 Dec 2024 - 31 Jan 2025",
    image: "/promotions/2.png",
    url: "https://www.dusit.com/dusitthani-manila/specialoffers/?gad_source=1&gclid=Cj0KCQiA8fW9BhC8ARIsACwHqYqrZq8c-7qn5m8GuzoNQh2G7GxH2sK-3SiOYYgCMYMhpxt828d32REaArXgEALw_wcB",
  },
  {
    title: "Executive Essentials",
    description:
      "Enjoy a luxurious 5-day stay with exclusive savings on premium rooms and gourmet dining.",
    image: "/promotions/3.png",
    url: "https://www.dusit.com/dusitthani-manila/specialoffers/?gad_source=1&gclid=Cj0KCQiA8fW9BhC8ARIsACwHqYqrZq8c-7qn5m8GuzoNQh2G7GxH2sK-3SiOYYgCMYMhpxt828d32REaArXgEALw_wcB",
  },
  {
    title: "Indulge in Decadence",
    description:
      "Treat yourself or someone special to luxurious sweets with vouchers from our patisserie.",
    image: "/promotions/4.png",
    url: "https://www.dusit.com/dusitthani-manila/specialoffers/?gad_source=1&gclid=Cj0KCQiA8fW9BhC8ARIsACwHqYqrZq8c-7qn5m8GuzoNQh2G7GxH2sK-3SiOYYgCMYMhpxt828d32REaArXgEALw_wcB",
  },
];
